export enum Background {
  SPACE = 'space',
  SEA = 'sea',
  SNOW = 'snow',
  NATURE = 'nature',
}
